import AddOnServices from 'components/AddOnServices';
import EvaluationComponent from 'components/Evaluation';
import PageSidebar from 'components/PageSidebar';
import ServicesComponent from 'components/Services';
import { useServiceCategoryAccess } from 'hooks';
import { FunctionComponent } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useFilteredServicesNavigation } from 'utils/PageSidebarUtils';
import PrivatePage from './PrivatePage';

interface ServicesProps {
    create: string;
}

export const Services: FunctionComponent<ServicesProps> = props => {
    const location = useLocation();
    const hash = location.hash.replace('#', '');
    const requiredCategory = hash === 'add_ons' ? null : hash === 'evaluation' ? 'evaluation' : 'grooming';
    const { isAllowed, redirectTo } = useServiceCategoryAccess(requiredCategory);
    const { selectedKey, setSelectedKey, sidebarItems } = useFilteredServicesNavigation('primary');

    const sidebar = (
        <PageSidebar
            title="Services"
            items={sidebarItems}
            selectedKey={selectedKey}
            onSelect={setSelectedKey}
        />
    );

    if (!isAllowed) {
        return <Redirect to={redirectTo} />;
    }

    return (
        <PrivatePage
            title="Services - Cuddles"
            pageName="/services"
            pageSidebar={sidebar}
        >
            {selectedKey === 'primary' && <ServicesComponent {...props} />}
            {selectedKey === 'add_ons' && <AddOnServices />}
            {selectedKey === 'evaluation' && <EvaluationComponent />}
        </PrivatePage>
    );
};

export default Services;
